import { msg } from "@lingui/core/macro";
import { MessageDescriptor } from "@lingui/core";
import { Language } from "src/utils/localization/languages/types";
import { CountryCode } from "@silversea-ssc/dotcom-read-model-types/Common";

export type SpecialTypeFilterMap = {
  key: string;
  value: string;
  label: MessageDescriptor;
};

const specialTypeFiltersMapping: Record<string, SpecialTypeFilterMap> = {
  AntarcticaBridge: {
    key: "cruiseGroup",
    value: "AntarcticaBridge",
    label: msg`Antarctica Bridge`
  },
  TopCruise: {
    key: "content.specialType",
    value: "TopCruise",
    label: msg`Top Cruise`
  }
};

export const specialTypeFilterFor = (
  specialTypeFilter: string | undefined
): SpecialTypeFilterMap | undefined =>
  specialTypeFilter ? specialTypeFiltersMapping[specialTypeFilter] : undefined;

export const cruiseAttributesToRetrieve = (
  language: Language,
  countryCode: CountryCode | undefined
) => {
  const attributesToRetrieve = [
    "objectID",
    "available",
    "days",
    "departurePort",
    "arrivalPort",
    "destinationWebCodes",
    "cruiseType",
    "cruiseGroup",
    "comboType",
    `countries.${countryCode}.p`,
    `countries.${countryCode}.c`,
    `countries.${countryCode}.pc`,
    `countries.${countryCode}.f`,
    "content.image",
    "content.shipId",
    "content.image",
    ...languageSpecificAttributePathOrEn("content.url", language),
    ...languageSpecificAttributePathOrEn("cruiseTagsTree", language),
    ...languageSpecificAttributePathOrEn("destinationNames", language),
    "arrivalPort.itineraryDate",
    "arrivalPort.cityCode",
    ...languageSpecificAttributePathOrEn("arrivalPort.city", language),
    ...languageSpecificAttributePathOrEn("arrivalPort.country", language),
    ...languageSpecificAttributePathOrEn("arrivalPort.region", language),
    "departurePort.itineraryDate",
    "departurePort.cityCode",
    ...languageSpecificAttributePathOrEn("departurePort.city", language),
    ...languageSpecificAttributePathOrEn("departurePort.country", language),
    ...languageSpecificAttributePathOrEn("departurePort.region", language)
  ];

  return attributesToRetrieve;
};

const languageSpecificAttributePathOrEn = (
  path: string,
  language: Language
): string[] => {
  const enPath = `${path}.en`;
  if (language.code === "en") {
    return [enPath];
  }
  return [`${path}.${language.sanityCode}`, enPath];
};

export const hierarchicalFacetValue = (value: string) => {
  const parts = value.split(" > ");
  return parts[parts.length - 1];
};
